module.exports = __webpack_public_path__ + "static/media/BlueTransporter.6660a9dc.svg";